/* Pure Soul — theme.js */
function openMobileMenu(){document.getElementById('mob-drawer').classList.add('open');document.body.style.overflow='hidden'}
function closeMobileMenu(){document.getElementById('mob-drawer').classList.remove('open');document.body.style.overflow=''}
function openCart(){document.getElementById('cart-drawer').classList.add('open');document.body.style.overflow='hidden'}
function closeCart(){document.getElementById('cart-drawer').classList.remove('open');document.body.style.overflow=''}
function openSearch(){window.location='/search'}
function openSizeGuide(){const e=document.getElementById('sg-overlay');if(e){e.classList.add('open');document.body.style.overflow='hidden'}}
function closeSizeGuide(){const e=document.getElementById('sg-overlay');if(e){e.classList.remove('open');document.body.style.overflow=''}}
function handleSgClick(e){if(e.target===document.getElementById('sg-overlay'))closeSizeGuide()}
document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeMobileMenu();closeCart();closeSizeGuide()}});

function setUnit(u,btn){
  document.querySelectorAll('.unit-btn').forEach(b=>b.classList.remove('active'));
  btn.classList.add('active');
  document.querySelectorAll('#sg-table tbody tr').forEach(r=>{
    r.querySelector('.vc').textContent=r.dataset[u+'Chest'];
    r.querySelector('.vw').textContent=r.dataset[u+'Waist'];
    r.querySelector('.vh').textContent=r.dataset[u+'Hips'];
  });
}

function selectSize(btn){
  document.querySelectorAll('.size-btn').forEach(b=>b.classList.remove('sel'));
  btn.classList.add('sel');
  const vi=document.getElementById('variant-id');
  if(vi)vi.value=btn.dataset.variantId;
  const e=document.getElementById('size-err');
  if(e)e.classList.remove('show');
}

function toggleAcc(trigger){
  const item=trigger.closest('.acc-item');
  const open=item.classList.contains('open');
  document.querySelectorAll('.acc-item').forEach(i=>i.classList.remove('open'));
  if(!open)item.classList.add('open');
}

function toggleFaq(trigger){
  const item=trigger.closest('.faq-item');
  const open=item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(i=>i.classList.remove('open'));
  if(!open)item.classList.add('open');
}

let filtersOpen=false;
function toggleFilters(){
  filtersOpen=!filtersOpen;
  const b=document.getElementById('collection-body');
  const t=document.getElementById('filter-toggle-btn');
  if(b)b.classList.toggle('open',filtersOpen);
  if(t)t.style.color=filtersOpen?'var(--text)':'';
}
function setCategory(btn,cat){
  document.querySelectorAll('.fpill').forEach(p=>p.classList.remove('active'));
  btn.classList.add('active');
  const cards=document.querySelectorAll('.pcard');
  cards.forEach(c=>{c.style.display=(cat==='all'||c.dataset.category===cat)?'':'none'});
  const vis=cat==='all'?cards.length:[...cards].filter(c=>c.dataset.category===cat).length;
  const ct=document.getElementById('product-count');
  if(ct)ct.textContent=vis+' pieces';
}

document.addEventListener('DOMContentLoaded',function(){
  /* Carousel */
  const track=document.getElementById('car-track');
  const wrap=document.getElementById('car-wrap');
  const counter=document.getElementById('car-counter');
  const fill=document.getElementById('car-fill');
  if(!track||!wrap)return;
  const slides=track.querySelectorAll('.car-slide');
  const total=slides.length;
  let current=0;
  function goTo(i){
    current=(i+total)%total;
    track.style.transform=`translateX(-${current*100}%)`;
    if(counter)counter.textContent=(current+1)+' / '+total;
    if(fill)fill.style.width=((current+1)/total*100)+'%';
  }
  if(total>0)goTo(0);
  let sx=0,drag=false,delta=0;
  function start(x){sx=x;drag=true;delta=0;track.classList.add('drag');wrap.classList.add('grab')}
  function move(x){if(!drag)return;delta=x-sx;track.style.transform=`translateX(calc(-${current*100}% + ${delta}px))`}
  function end(){if(!drag)return;drag=false;track.classList.remove('drag');wrap.classList.remove('grab');const t=wrap.offsetWidth*.18;if(delta<-t)goTo(current+1);else if(delta>t)goTo(current-1);else goTo(current)}
  wrap.addEventListener('mousedown',e=>{e.preventDefault();start(e.clientX)});
  wrap.addEventListener('touchstart',e=>start(e.touches[0].clientX),{passive:true});
  wrap.addEventListener('touchmove',e=>move(e.touches[0].clientX),{passive:true});
  wrap.addEventListener('touchend',()=>end());
  window.addEventListener('mousemove',e=>move(e.clientX));
  window.addEventListener('mouseup',()=>end());

  /* Add to cart */
  const form=document.getElementById('product-form');
  if(form){
    form.addEventListener('submit',async function(e){
      e.preventDefault();
      const sg=document.querySelector('.size-grid');
      const sel=document.querySelector('.size-btn.sel');
      if(sg&&!sel){const err=document.getElementById('size-err');if(err)err.classList.add('show');return}
      const vi=document.getElementById('variant-id');
      if(!vi)return;
      const btn=document.getElementById('atc-btn');
      if(btn){btn.textContent='Adding...';btn.disabled=true}
      try{
        await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vi.value,quantity:1})});
        const cart=await(await fetch('/cart.js')).json();
        const ct=document.getElementById('cart-count');
        if(ct)ct.textContent=cart.item_count;
        if(btn){btn.textContent='Added ✓';btn.classList.add('added');setTimeout(()=>{btn.textContent='Add to cart';btn.classList.remove('added');btn.disabled=false},1800)}
        openCart();
      }catch(err){if(btn){btn.textContent='Add to cart';btn.disabled=false}}
    });
  }

  /* Refresh cart count */
  fetch('/cart.js').then(r=>r.json()).then(c=>{const ct=document.getElementById('cart-count');if(ct)ct.textContent=c.item_count}).catch(()=>{});
});
